import { IAuditOnsiteFieldInfo } from "../../../../../interfaces";


export const getMaxCountValueHandler = (fields: IAuditOnsiteFieldInfo[]): number =>
  fields.reduce((acc: number, el: IAuditOnsiteFieldInfo) => acc + el.maximumPoints, 0)